import React from "react";

type AgendaItem = {
  time: string;
  description1: string;
  description2?: string;
};

type AgendaProps = {
  headers: string[];
  agenda: AgendaItem[];
};

const styles = {
  container: {
    backgroundColor: "#0f0f1a",
    color: "white",
    padding: "24px",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
    maxWidth: "1000px",
    margin: "40px auto",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0 8px",
  },
  th: {
    textAlign: "left" as const,
    fontSize: "0.875rem",
    textTransform: "uppercase" as const,
    color: "#9ca3af",
    padding: "8px 16px",
    /*borderBottom: "1px solid #374151",*/
  },
  row: {
    backgroundColor: "#1a1a2e",
    transition: "background-color 0.2s ease-in-out",
  },
  rowHover: {
    backgroundColor: "#2a2a40",
  },
  td: {
    padding: "12px 16px",
    border: "1px solid #374151",
  },
  tdFirst: {
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
    width: "100px",
    textAlign:  "center" as const
  },
  tdLast: {
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
  },
};

export default function Agenda({ headers = [], agenda = [] }: AgendaProps) {
  return (
    <div style={styles.container}>
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0 8px",
        }}
      > 
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index} style={styles.th}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {agenda.map((item, index) => (
            <tr
              key={index}
              style={styles.row}
              onMouseEnter={(e) =>
                ((e.currentTarget as HTMLTableRowElement).style.backgroundColor =
                  styles.rowHover.backgroundColor)
              }
              onMouseLeave={(e) =>
                ((e.currentTarget as HTMLTableRowElement).style.backgroundColor =
                  styles.row.backgroundColor)
              }
            >
              <td style={{ ...styles.td, ...styles.tdFirst }}>{item.time}</td>

              {item.description2 ? (
                <>
                  <td style={styles.td}>{item.description1}</td>
                  <td style={{ ...styles.td, ...styles.tdLast }}>
                    {item.description2}
                  </td>
                </>
              ) : (
                <td
                  colSpan={2}
                  style={{ ...styles.td, ...styles.tdLast }}
                >
                  {item.description1}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
